import { API, authClient } from "../index";

export const getMailConfig = (accessToken) => {
  return authClient(accessToken).get(`${API}/config/mail`);
};

export const updateMailConfig = (mailConfig, accessToken) => {
  return authClient(accessToken).put(`${API}/config/mail`, mailConfig);
};

export const testMailImap = (mailConfig, accessToken) => {
  return authClient(accessToken).post(`${API}/config/mail/test-imap`, mailConfig);
};

export const testMailSmtp = (mailConfig, accessToken) => {
  return authClient(accessToken).post(`${API}/config/mail/test-smtp`, mailConfig);
};
